import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { putUpdatePassword } from '../../actions/auth';
import eyeShut from '../../img/icons8-eye-50.png';
import eyeOpen from '../../img/icons8-eye-50-2.png';
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment';
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import backgroundImage from "../../img/LEVLR-Login-Background.jpg";
import levlr_logo from "../../img/LEVLR Logo_CMYK.png";

  const ResetPassword = props => {
    
    const [match, setMatch] = useState(false)
    const [response, setResponse] = useState({})
    const [credentials, setCredentials] = useState({})
    const [showPassword, setShowPassword] = useState(false); // Show/hide toggle
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate()
    const dispatch = useDispatch();

    useEffect(() => {
        //getReset(params); 
        sessionTimeout()
        compareToken(token)   
    }, [sessionTimeout()])

    function sessionTimeout() {
        let now = new Date()
        let expire = new Date(response.resetPasswordExpires)
        if (expire.getTime() < now.getTime()) {
            alert("Your Reset Session Timed Out!")
            navigate(`/login`)
        }
        else {
           // console.log("NOT EXPIRED")
        }
    }

    let { token } = useParams();

    const compareToken = async (token) => {
        const response = await fetch(
            `${process.env.REACT_APP_TOKEN}/${token}`
        ).then((response) => response.json({}));
        setResponse(response)
    }

    function validatePassword() {
        if (document.getElementById('password') === null) {
            return false
        }
        else {
            var p = document.getElementById('password').value,
            errors = [];
            if (p.length < 10) {
                errors.push("10 characters. \n");
            }
            if (p.search(/[a-z]/) < 0) {
                errors.push("1 lowercase letter. \n"); 
            }
            if (p.search(/[A-Z]/) < 0) {
                errors.push("1 uppercase letter. \n"); 
            }
            if (p.search(/[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]/i) < 0) {
                errors.push("1 special character. \n"); 
            }
            {/*
            if (p.search(/[0-9]/) < 0) {
                errors.push("1 digit. \n");
            }
            */}
            if (errors.length > 0) {
                return (errors)
            }
        return true
        }
    }

    function validateConfirm() {
        if((document.getElementById('password') === null) && (document.getElementById('confirm') === null)) {
            return false
        }
        if((document.getElementById('password') === null) || (document.getElementById('confirm') === null)) {
            return false
        }
        if((document.getElementById('password') === undefined) && (document.getElementById('confirm') === undefined)) {
            return false
        }
        if((document.getElementById('password') === undefined) || (document.getElementById('confirm') === undefined)) {
            return false
        }
        else {
            if (document.getElementById('password').value === document.getElementById('confirm').value) {
                return true
            }
            else {
                return false
            }
        }
    }

    const handleConfirm = e => {
        if (e.target.value === document.getElementById('password').value) {
            setMatch(true)
        }
        else {
            setMatch(false)
        }
    }

    function allowReset() {
        if ((validateConfirm() === true) && (validatePassword() === true)) {
            return loginButtonStyle
        }
        else {
            return loginButtonStyleDisabled
        }
    }

    function renderPasswordRequirements() {
        if(validatePassword() === undefined) {
            return
        }
        if(validatePassword().length != undefined) {
            return (
                <div style={requirementStyles}>
                    {validatePassword().map((req, i) =>
                        <span style={noPadding} key={i}>{req}</span>
                    )}
                </div>
            )
        }
    }
 
    const handleChange = e => {
        setCredentials({ ...credentials, 
            email: response.email,
            [e.target.name]: e.target.value})
    }

    const routeChange = () => { 
        let path = `/login`; 
        navigate(path);
    }

    function returnToLogin() {
        let path = `/login`; 
        navigate(path);
    }

    const updatePassword = e => {
        e.preventDefault()
        returnToLogin()
        dispatch(putUpdatePassword({ props, credentials })) 
    };

    const backGroundStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage: `url(${backgroundImage})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      height: '100%',
      paddingBottom: '10%',
      paddingTop: '10%'
  }

  const noPadding = {
    padding: '0 0',
    margin: '0 0'
  }

  const requirementStyles = {
    padding: '0 0',
    margin: '0 0',
    display: 'inline',
    width: '65%',
    height: 'auto',
    textAlign: 'left',
    fontSize: '1.75vh',
    fontWeight: 'bold',
    color: 'rgb(1, 101, 106)'
}

  const loginPaperStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      width: '70%',
      height: 'auto',
      paddingTop: '4vh',
      paddingBottom: '4vh',
      marginLeft: 'auto',
      marginRight: 'auto'
  }
  
  const loginTextFieldStyle = {
      width: '65%',
      height: 'auto'
  }
  
  const loginFormStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      marginTop: 1
  }
  
  const loginButtonStyle = {
      width: '50%',
      color: "white",
      backgroundColor: "#2fb7b7",
      '&:hover': {
          backgroundColor: '#01656a'
      },
      margin: 16
  }

  const loginButtonStyleDisabled = {
    pointerEvents: 'none',
    width: '50%',
    color: "white",
    backgroundColor: "#01656a",
    margin: 16,
}

  const levlrLogoStyle = {
      width: '40%',
      height: 'auto'
  } 
  
      return (
        <div className="Background-Container" style={backGroundStyle}>
        <Container component="main" maxwidth="xs">
                <CssBaseline />
                <Paper style={loginPaperStyle}>
                    <img src={levlr_logo} style={levlrLogoStyle} alt="Levlr Logo"/>
                    <form style={loginFormStyle} noValidate onSubmit={(e) => updatePassword(e)}>
                      <div>Please Note: Passwords are Case Sensitive</div>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            id="email"
                            name="email"
                            value={response.email}
                            disabled={true}
                            autoFocus
                            onChange={handleChange}
                            style={loginTextFieldStyle}
                            InputProps={{
                                style: { backgroundColor: '#eff0f0', borderRadius: 4 }
                            }}
                            sx={{
                                '& input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 1000px #eff0f0 inset',
                                WebkitTextFillColor: '#000',
                                transition: 'background-color 5000s ease-in-out 0s'
                                }
                            }}
                            />

                            <div> Enter A New Password </div>

                            {/* Password with eye toggle */}
                            <TextField
                            variant="outlined"
                            margin="normal"
                            required={true}
                            id="password"
                            label="Password"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            helperText={renderPasswordRequirements()}
                            onChange={handleChange}
                            style={loginTextFieldStyle}
                            InputProps={{
                                style: { backgroundColor: '#eff0f0', borderRadius: 4 },
                                endAdornment: (
                                <InputAdornment position="end">
                                    <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        background: 'inherit',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: 0,
                                        margin: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%'
                                    }}
                                    >
                                    <img
                                        src={showPassword ? eyeShut : eyeOpen}
                                        alt={showPassword ? 'Hide password' : 'Show password'}
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                    </button>
                                </InputAdornment>
                                )
                            }}
                            sx={{
                                '& input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 1000px #eff0f0 inset',
                                WebkitTextFillColor: '#000',
                                transition: 'background-color 5000s ease-in-out 0s'
                                }
                            }}
                            />

                            {/* Confirm Password with eye toggle */}
                            <TextField
                            variant="outlined"
                            margin="normal"
                            required={true}
                            id="confirm"
                            label="Confirm Password"
                            name="password"
                            type={showConfirmPassword ? 'text' : 'password'}
                            style={loginTextFieldStyle}
                            onChange={handleConfirm}
                            error={!match}
                            helperText={match ? ' ' : 'Passwords Do Not Match.'}
                            InputProps={{
                                style: { backgroundColor: '#eff0f0', borderRadius: 4 },
                                endAdornment: (
                                <InputAdornment position="end">
                                    <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        background: 'inherit',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: 0,
                                        margin: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%'
                                    }}
                                    >
                                    <img
                                        src={showConfirmPassword ? eyeShut : eyeOpen}
                                        alt={showConfirmPassword ? 'Hide password' : 'Show password'}
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                    </button>
                                </InputAdornment>
                                )
                            }}
                            sx={{
                                '& input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 1000px #eff0f0 inset',
                                WebkitTextFillColor: '#000',
                                transition: 'background-color 5000s ease-in-out 0s'
                                }
                            }}
                            />
                    <Button
                        type="submit"
                        variant="contained"
                        style={allowReset()}
                    >
                        Reset Your Password
                    </Button>
                  </form>

                    <Button
                        type="submit"
                        variant="contained"
                        style={loginButtonStyle}
                        onClick={routeChange}
                    >
                        Return to Login
                    </Button>
                </Paper>
            </Container>
           
           </div>
      );
          };
        
  
 export default ResetPassword;
